module.exports = __webpack_public_path__ + "img/big1-3.1a8cd65c.jpg";